import {combineReducers} from 'redux';

import {carAuditReducer} from './carAudit/reducer';
import {commonReducer} from './common/reducer';
import {documentSeriesReducer} from './documentSeries/reducer';
import {interestSeriesDefinitionReducer} from './interestSeries/reducer';
import {vehicleCatalogueReducer} from './vehicleCatalogue/reducer';
import {vehicleSettingsReducer} from './vehicleSettings/reducer';

export const teasReducers = {
  common: commonReducer,
  vehicleCatalogue: vehicleCatalogueReducer,
  generalSettings: combineReducers({
    documentSeries: documentSeriesReducer,
    vehicleSettings: vehicleSettingsReducer,
    interestSettings: combineReducers({
      interestSeriesDefinition: interestSeriesDefinitionReducer,
    }),
  }),
  carAudit: carAuditReducer,
};

const reducers = combineReducers({...teasReducers});
export type TeasReducers = typeof reducers;
